import IDataService from './IData.service';

export default class IComplianceAppDataService extends IDataService {
  /**
   *
   * @param {Object} $http - The Angular injected $http service
   * @param {Object} utilityService - The Angular injected service
   * @param {string} appTLA - The Compliance app acronym for API paths
   * @param {Object} [normalizations] - Hash of string overrides to normalize variations in the API
   */
  constructor(
    $http, // TODO: switch to fetch (with polyfill) for forward compatibility
    utilityService, // TODO: We don't need this injected by Angular, change globally to import
    appTLA,
    normalizations = {}
  ) {
    super($http, utilityService);

    /**
     * Provide default normalization values
     * @type {string}
     */
    const { settings = 'setting' } = normalizations;

    this.appTLA = appTLA;
    this.settings = settings;
    console.log('app.services.IComplianceAppDataService created');
  }


  /** ******************************************************
   * Settings
   */

  /**
   *
   * @param {int} [customerId] - if supplied, filters by customer id
   * @return {Promise|settings} - the settings object
   */
  getSettings(customerId = null) {
    if (customerId) {
      return this.$http({
        url: `${this.apiRootUrl}/${this.appTLA}/${this.settings}/byCustomer`,
        method: 'GET',
        params: {
          customerId,
        },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/${this.appTLA}/${this.settings}`,
      method: 'GET',
    });
  }

  saveSettings(settings) {
    return this.$http({
      url: `${this.apiRootUrl}/${this.appTLA}/${this.settings}`,
      method: 'PUT',
      data: JSON.stringify(settings),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  /** ******************************************************
   * Reports
   */

  getReports() {
    return this.$http({
      url: `${this.apiRootUrl}${this.appTLA}/report`,
      method: 'GET',
    });
  }

  /**
   *
   * @param {string} name - String name of the report
   * @return {*} The report object
   */
  getReportByName(name) {
    return this.$http({
      url: `${this.apiRootUrl}/report/byName`,
      method: 'GET',
      params: {
        name,
      },
    });
  }

  generateFullReport(reportParams, cookieName) {
    const payload = {
      action: 'generateFullReport',
      ...reportParams,
    };
    payload[`${this.appTLA}CookieName`] = cookieName;

    return this.$http({
      url: `${this.apiRootUrl}/report/render/${this.appTLA}`,
      method: 'POST',
      data: this.serializeData(payload),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'arraybuffer',
    });
  }

  archiveReport(reportId, parameters) {
    return this.$http({
      url: `${this.apiRootUrl}/${this.appTLA}/report/${reportId}/archive`,
      method: 'PUT',
      data: this.serializeData({
        parameters: JSON.stringify(parameters),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }
}
